<template>
    <div class="offers-table">
        <trust-pilot />
        <div class="adv-disclosure-block">
            <template v-if="ShowHdltgp">
                <button id="ltPaidBtn" class="lt-paid a11y-modal-trigger" data-target="ltPaid">
                    {{ ltPaidTitle }}
                </button>
                <div class="dsk-lt-paid">
                    <tooltip-view :label="ltPaidTitle" :show-on-over="ShowOnOver" :popper-content="ltPaidDescription" referenceElement="open me" />
                </div>
            </template>
            <advertising-disclosures
                v-if="DisclosureText"
                :disclosure-text="disclosureText"
                :disclosure-tokens="disclosureTokens"
                :open-disclosure-modal="openDisclosureModal"
            />
        </div>
        <div v-for="(offerDetails, index) in apiResponse" :key="index" class="container-fluid lenderTable">
            <div class="container">
                <div v-if="offerDetails.template && offerDetails.template.html">
                    <v-runtime-template :template="offerDetails.template.html" />
                </div>
                <div v-else class="row">
                    <div class="col-xs-12 col-sm-4 lender-logo">
                        <thank-you-debt-relief-popup
                            :lender-name="offerDetails.lender.name"
                            :lender-lending-entity-id="offerDetails.lender.lendingEntityId"
                            :logo-url="offerDetails.lender.logoUrl"
                            :destination-url="offerDetails.placement.destinationUrl"
                            :loan-amount="amount"
                            :state="state"
                            :lead-guid="leadGuid"
                            :partner-type="offerDetails.placement.vertical"
                            :variation-name="offerDetails.placement.variationName"
                            :placement="placement"
                        />
                        <div class="star-rating-section">
                            <div v-if="offerDetails.lender.review.result && lenderReviewCount(offerDetails)" class="rating-star">
                                <div
                                    class="rating-stars-top" :style="{'width':lenderPercentOverallRating((offerDetails.lender.review.result.statistics != null) ?
                                        offerDetails.lender.review.result.statistics.averageOverallRating : 0) }"> <!-- Accounts for if R&R API is not working correctly -->
                                    <span class="lt-icons lt4-Star"></span>
                                    <span class="lt-icons lt4-Star"></span>
                                    <span class="lt-icons lt4-Star"></span>
                                    <span class="lt-icons lt4-Star"></span>
                                    <span class="lt-icons lt4-Star"></span>
                                </div>
                                <div class="rating-stars-bottom">
                                    <span class="lt-icons lt4-Star"></span>
                                    <span class="lt-icons lt4-Star"></span>
                                    <span class="lt-icons lt4-Star"></span>
                                    <span class="lt-icons lt4-Star"></span>
                                    <span class="lt-icons lt4-Star"></span>
                                </div>
                            </div>
                        </div>
                        <div class="ratingsLink">
                            <review-link
                                :content-key-for-reviews="offerDetails.lender.reviewId"
                                :review-count="reviewCount(offerDetails)"
                                @click="getTrackDetails(offerDetails.lender.name, offerDetails.placement.vertical, true)"
                            />
                        </div>
                    </div>
                    <div class="col-xs-12 col-sm-4 aprRange">
                        <ul>
                            <li v-for="(item, itemIndex) in offerDetails.placement.marketingBullets" :key="itemIndex">
                                {{ item }}
                            </li>
                        </ul>
                    </div>
                    <div class="col-xs-12 col-sm-4 text-right call">
                        <div v-show="offerDetails.placement.showCtaIndicator">
                            <thank-you-debt-relief-popup
                                :lender-name="offerDetails.lender.name"
                                :lender-lending-entity-id="offerDetails.lender.lendingEntityId"
                                :logo-url="offerDetails.lender.logoUrl"
                                :destination-url="offerDetails.placement.destinationUrl"
                                :loan-amount="amount"
                                :state="state"
                                :lead-guid="leadGuid"
                                :cta-text="offerDetails.placement.ctaText"
                                :partner-type="offerDetails.placement.vertical"
                                :variation-name="offerDetails.placement.variationName"
                                :placement="placement"
                            />
                        </div>
                        <div v-show="offerDetails.placement.showScheduleIndicator">
                            <contact-popup :contact-btn-text="contactBtnText" contactBtnClass="btn btn-blue" :lender-name="offerDetails.lender.name" :contact-number="lenderContact(offerDetails.placement.phoneNo)" :vertical="vertical" :placement="placement" :lending-entity-id="offerDetails.lender.lendingEntityId" :variation-name="offerDetails.placement.variationName" />
                        </div>
                        <div v-show="offerDetails.placement.showPhoneIndicator">
                            <a :href="'tel:' +lenderContact(offerDetails.placement.phoneNo)" class="contact-no"><span v-show="offerDetails.placement.showScheduleIndicator || offerDetails.placement.showCtaIndicator">Or </span>Call <span>{{ lenderContact(offerDetails.placement.phoneNo) }}</span></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <a11y-modal v-if="ShowHdltgp" id="ltPaid">
            <template #h4> {{ ltPaidTitle }} </template>
            <div slot="body">
                <div class="description"> <p> {{ ltPaidDescription }} </p></div>
            </div>
        </a11y-modal>
    </div>
</template>

<script>
    import VRuntimeTemplate from 'v-runtime-template';
    import URLs from '../constants/urls';
    import AdvertisingDisclosures from './advertising-disclosures.vue';
    import ThankYouDebtReliefPopup from './thank-you-debt-relief-popup.vue';
    import TrackDataHelper from '../helpers/track-data-helper';
    import AnalyticsTrack from '../mixin/analytics-track';
    import AnalyticsHelper from '../helpers/analytics';
    import ContactPopup from './preprime-contact-popup.vue';
    import ReviewLink from './review-link.vue';
    import ReviewCount from '../mixin/review-count';
    import TrustPilot from './trust-pilot.vue';
    import a11yModal from '../helpers/a11y-modal';
    import A11yModal from './a11y-modal.vue';
    import TooltipView from './tooltip-view.vue';

    export default {
        props: {
            apiResponse: {
                default: [],
            },
            amount: {
                default: '',
            },
            state: {
                default: '',
            },
            leadGuid: {
                default: '',
            },
            vertical: {
                default: 'debt relief',
            },
            placement: {
                default: 'debt-relief-landing-v2',
            },
            contactBtnText: {
                default: 'Contact',
            },
            disclosureText: {
                default: 'Disclosures',
            },
            disclosureTokens: {
                default: '00115',
            },
            ltPaidTitle: {
                default: 'How Does LendingTree Get Paid?',
            },
            ltPaidDescription: {
                default: 'LendingTree is compensated by companies on this site and this compensation may impact how and where offers appears on this site (such as the order). LendingTree does not include all lenders, savings products, or loan options available in the marketplace.',
            },
            showOnOver: {
                default: true,
            },
            openDisclosureModal: {
                default: true,
            },
            hideHdltgp: {
                default: false,
            },
        },
        data() {
            return {
                ShowFreeedomPopup: false,
                ShowOnOver: this.showOnOver,
                ShowHdltgp: !this.hideHdltgp,
                DisclosureText: this.disclosureText,
            };
        },
        methods: {
            lenderContact(contactNumber) {
                let number = contactNumber;
                if (number) {
                    number = contactNumber.replace('+1', '')
                        .replace(/[^0-9]/g, '')
                        .replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
                }
                return number;
            },
            lenderPercentOverallRating(rating) {
                return rating != null ? `${rating / 5.0 * 100.0}%` : 0; // Accounts for if R&R API is not working correctly
            },
            lenderReviewCount(offerDetails) {
                try {
                    return offerDetails.lender.review.result.statistics.reviewCount;
                } catch (e) {
                    console.warn(e); // Log if there is an error (typically this will be if the R&R API is not working)
                    return 0;
                }
            },
            getInterstitialUrl(vendorName, vendorLogoUrl, targetUrl) {
                return `${URLs.LT_WWW_URL}/interstitial/mylt?partnername=${encodeURIComponent(vendorName)}&partnerlogo=${vendorLogoUrl}&partnerurl=${encodeURIComponent(targetUrl)}`;
            },
            closePopup() {
                this.ShowFreeedomPopup = false;
            },
            getTrackDetails(lenderName, vertical, isReviewClicked) {
                const eventName = isReviewClicked ? 'Preprime Partner Reviews Clicked' : 'Preprime Partner Viewed';
                TrackDataHelper.setMany(this.trackResultsInDebtRelief(lenderName, vertical), 'debtReliefResults');
                AnalyticsHelper.track(eventName, TrackDataHelper.get('debtReliefResults'));
                this.IsReviewClicked = false;
            },
            makeTrackCalls() {
                for (let i = 0; i < this.apiResponse.length; i++) {
                    this.getTrackDetails(this.apiResponse[i].lender.name, this.apiResponse[i].placement.vertical, false);
                }
            },
            showCTA(showScheduleIndicator, showCtaIndicator) {
                return showScheduleIndicator || showCtaIndicator;
            },
            addListClass() {
                const listEl = document.querySelectorAll('.aprRange ul');
                listEl.forEach((element) => {
                    element.classList.add('checklist');
                });
            },
        },
        mounted() {
            this.makeTrackCalls();
            this.addListClass();
            setTimeout(() => {
                a11yModal.initModal();
            }, 1000);
        },
        components: {
            VRuntimeTemplate,
            ThankYouDebtReliefPopup,
            ContactPopup,
            ReviewLink,
            TrustPilot,
            A11yModal,
            TooltipView,
            AdvertisingDisclosures,
        },
        mixins: [AnalyticsTrack, ReviewCount],
    };
</script>

<style src="../../assets/styles/a11yModal.scss" lang="scss"></style>
<style lang="scss">
@import "../../assets/styles/variables";
@import "../../assets/styles/v2/variables";

#lt-yantr {
    .offers-table {
        position: relative;

        .lenderTable {
            min-height: 130px;
            border-bottom: 1px solid $steam;
            padding: 60px 0 20px;

            @media #{$mob-landscape-view} {
                padding: 30px 0;
            }
        }

        .lender-logo {
            text-align: center;

            @media #{$mob-landscape-view} {
                margin-bottom: 10px;
            }

            a {
                cursor: pointer;
            }

            .view-site-btn {
                display: none;
            }

            .logo img {
                max-width: 200px;
                max-height: 110px;
                margin-bottom: 20px;
            }
        }

        .call {
            text-align: center;

            .contact-no {
                color: $brand-dark-blue;
                font-weight: $fw-bold;
                display: inline-block;
            }

            .logo {
                display: none;
            }

            .btn {
                font-weight: $fw-normal;
                margin-bottom: 10px;
                min-width: 147px;

                @media #{$mob-landscape-view} {
                    width: 320px;
                }

                @media #{$mob-portrait-view} {
                    width: 100%;
                }
            }
        }

        .checklist {
            @media #{$mob-landscape-view} {
                max-width: 320px;
                margin: 0 auto 20px;
            }

            @media #{$mob-portrait-view} {
                max-width: 320px;
            }
        }

        .adv-disclosure-block {
            text-align: right;
            width: 100%;
            max-width: 1140px;
            margin: 0 auto;

            @media #{$mob-landscape-view} {
                padding: 0 15px;
            }

            .lt-paid {
                font-size: $fs-12;
                text-transform: capitalize;
                color: $brand-blue;
                background: transparent;
                line-height: 15px;
                float: left;
                display: none;
                border: none;

                &:focus {
                    margin-left: 2px;
                    padding: 2px;
                    outline: 5px auto Highlight;
                    outline: 5px auto -webkit-focus-ring-color;
                }

                @media #{$mob-landscape-view} {
                    line-height: inherit;
                    display: block;
                    position: static;
                }
            }

            .disclosure-link {
                @media #{$mob-landscape-view} {
                    margin-top: 0;
                }
            }

            .dsk-lt-paid {
                float: left;

                button {
                    font-size: $fs-12;
                    font-weight: normal;
                    line-height: 2.8em;
                    text-transform: capitalize;
                    color: $brand-blue;
                    display: block;
                    margin-bottom: 0;
                    cursor: pointer;
                    background: transparent;
                    border: none;

                    &:focus {
                        padding: 2px;
                        outline: 5px auto Highlight;
                        outline: 5px auto -webkit-focus-ring-color;
                    }
                }

                .popper {
                    font-weight: $fw-light;
                    line-height: 22px;
                    text-align: left;
                    background: $white;
                    width: 325px;
                    height: 150px;
                    padding: 10px;
                    border: 1px solid $white;
                    border-radius: 6px;
                }

                .popper[x-placement^="bottom"] .popper__arrow {
                    margin-top: 0;
                    margin-bottom: 0;
                    border-width: 0 10px 10px 10px;
                    border-color: transparent transparent #fafafa transparent;
                    top: -10px;
                    left: calc(50% - 5px);
                }

                @media #{$mob-landscape-view} {
                    display: none;
                }
            }
        }
    }
}
</style>
